import React, { useRef, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { I18N, GlobalContext } from 'commons';
import FieldSection from 'components/forms/FieldSection';
import StateSection from 'components/forms/location-information/StateSection';
import DateSection from 'components/forms/location-information/DateSection';
import CountrySection from 'components/forms/location-information/CountrySection';
import VerifyLocationModal from 'components/modals/verify-location-address';
import * as locationSelectors from 'state/selectors/locationSelectors';
import * as locationActions from 'state/actions/locationActions';
import FieldErrorMessage from 'components/forms/FieldErrorMessage';
import Suggestion from 'components/forms/location-information/suggestion';
import { goNextPage, clearPosition } from 'utils/ebUtils';
import AlertInfoWin from 'components/modals/confirm-delete/alertInfoWin';
import { navigate } from '@reach/router';
import { selectShouldShowIncidentSub } from 'state/selectors/subscriptionSelectors';
import styled from 'styled-components';
import v from 'scss/v'
import LatitudeAndLongitude from './LatitudeAndLongitude';

const AddLocationInformationForm = ({
  isFullLocationPage,
  fetchInitData,
  countries,
  values,
  fetchAddresses,
  resetLocationValues,
  setFieldError,
  setFieldTouched,
  errors,
  setFieldValue,
  saveGeocodingAddress,
  touched,
  states,
  verifyLocation,
  geocodingAddresses,
  setIsAddressVerifyPass,
  isShowAddressVerifyTip,
  setShowAddressVerifyTip,
  isOpenEditLocation,
  closeLocation,
  isEmptyLocation,
  userAddressList,
  isEditMode,
  currentAddress,
  handleBlur,
  handleSubmit,
  isSubmit,
  setIsSubmit,
  shouldIncidentSubShow,
  isSubmitting,
  isOpenAddLocation,
  setSavedSucceed,
  isExpectedLocation,
  expLocEditable
}) => {
  const {
    organization: {
      addressSetting: {
        geocodingType = '',
        defaultAddressGeoCodingSource = '',
        editable: addresseEditable = false,
        mandatory: addressMandatory = false
      },
      showCustomfield,
      showAlertSubscription, showGroupSubscription,
      hasGeoFanceSetting,
    },
    account: { id: contactId },
  } = useContext(GlobalContext);
  const content = 'ssp.map.out.of.area.warning';
  const alertTitle = 'ssp.location.address.out.of.range';
  const [isOpenVerifyLocation, setIsOpenVerifyLocation] = useState(false);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [showlatitudeAndLongitude, setShowlatitudeAndLongitude] = useState(false);
  const [isShowAlertInfo, setIsShowAlertInfo] = useState(false);
  const [whichOnePosition, setWhichOnePosition] = useState(0);
  const [topErrorMessages, setTopErrorMessages] = useState([])
  const [scrollWatcher, setScrollWatcher] = useState(true)

  const cacheCountry = useRef(values.country);
  const verifyButton = useRef(null);
  const topErrorContainer = useRef(null)

  let onblurTimer;
  const handleOnblur = (event) => {
    if ((!isFullLocationPage && addressMandatory) || isFullLocationPage) {
      handleBlur(event)
    }
    onblurTimer = setTimeout(() => {
      if (!document.activeElement || !document.activeElement.attributes['suggestion-item'] || document.activeElement.attributes['suggestion-item'].nodeValue != 'true') {
        setShowSuggestion(false)
      }
    }, 300);
  };

  const getCountryName = (code, countriesProp) => {
    let countryName;
    if (!countriesProp) {
      countryName = _.get(countries.filter(item => _.isEqual(item.code, code)), '[0].value', '');
    } else {
      countryName = _.get(countriesProp.filter(item => _.isEqual(item.code, code)), '[0].value', '');
    }
    return countryName;
  };

  const getAddressesFromRemote = (countryList, addressValues, type) => {
    const { street, suite, city, postalCode, state, country } = addressValues;
    if (type === 'verify') {
      if (!addressValues.locationName) {
        setFieldError('locationName', 'jquery.validation.field.required, ssp.address.locationname');
        setFieldTouched('locationName', true, false);
      } else if (errors.locationName) {
        return false;
      }
      if (isExpectedLocation) {
        if (!addressValues.arriveDate) {
          setFieldError('arriveDate', 'jquery.validation.field.required, ssp.address.start.date');
          setFieldTouched('arriveDate', true, false);
        }
        if (!addressValues.expireDate) {
          setFieldError('expireDate', 'jquery.validation.field.required, ssp.address.end.date');
          setFieldTouched('expireDate', true, false);
        }
      }
      if (!addressValues.street) {
        setFieldError('street', 'jquery.validation.field.required, ssp.address.streetaddress');
        setFieldTouched('street', true, false);
      }
      if (addressValues.lat && (addressValues.lat < -90 || addressValues.lat > 90)) {
        setFieldError('lat', 'ssp.address.latitude.error');
        setFieldTouched('lat', true);
      }
      if (addressValues.lon && (addressValues.lon < -180 || addressValues.lon > 180)) {
        setFieldError('lon', 'ssp.address.longitude.error');
        setFieldTouched('lon', true);
      }
      if (
        !addressValues.locationName ||
        (isExpectedLocation && !addressValues.arriveDate) ||
        (isExpectedLocation && !addressValues.expireDate) ||
        !addressValues.street ||
        (addressValues.lat && (!_.trim(addressValues.lat) || !_.isFinite(Number(addressValues.lat)) || addressValues.lat < -90 || addressValues.lat > 90)) ||
        (addressValues.lon && (!_.trim(addressValues.lon) || !_.isFinite(Number(addressValues.lon)) || addressValues.lon < -180 || addressValues.lon > 180))
      ) {
        return false;
      }
    }
    fetchAddresses({
      addressGeoCodingSource: defaultAddressGeoCodingSource,
      queryAddress: {
        country: getCountryName(country, countryList),
        adminDistrict: _.trim(state),
        addressLine: `${_.trim(street)} ${_.trim(suite)} ${_.trim(city)}`,
        postalCode: _.trim(postalCode),
        locality: '',
        streetAddress: _.trim(street),
        suite: '',
      },
      callback: () => {
        if (type === 'verify') {
          setIsOpenVerifyLocation(true);
        } else if (!showSuggestion && street) {
          setShowSuggestion(true);
        }
      },
    });
  };
  const getAddresses = useRef(_.debounce(getAddressesFromRemote, 5000)).current;

  const handleAddressUpdate = (newAddress) => {
    const { street, streetAddress, suite, city, postalCode, state, adminDistrict, lat, lon } = newAddress;
    setFieldValue('street', street || streetAddress, false);
    setFieldValue('suite', suite, false);
    setFieldValue('city', city, false);
    setFieldValue('postalCode', postalCode, false);
    setFieldValue('state', state || adminDistrict, false);
    setFieldValue('lat', lat, false);
    setFieldValue('lon', lon, false);
  };

  const handleSuggestion = (index, item) => {
    clearTimeout(onblurTimer);
    const { lat, lon } = item;

    setWhichOnePosition(index);

    if (hasGeoFanceSetting) {
      const checkGeoParam = {
        position: { lat, lng: lon },
        successCallBack: () => {
          handleAddressUpdate(item);
          setShowSuggestion(false);
        },
        failCallBack: () => {
          setIsShowAlertInfo(true);
          setFieldValue('street', '', false);
        },
      };
      saveGeocodingAddress(checkGeoParam);
    } else {
      handleAddressUpdate(item);
      setShowSuggestion(false);
    }
  };

  useEffect(() => {
    if (_.isEmpty(countries)) fetchInitData();
  }, []);

  useEffect(() => {
    if (_.isEqual(values.country, 'US')) {
      if (states.indexOf(item => item.value === values.state) === -1) {
        states.forEach(sta => {
          if (sta.code === values.state) setFieldValue('state', sta.value, false);
        });
      }
    }
  }, [values, states]);

  useEffect(() => {
    if (isSubmit) {
      setShowAddressVerifyTip(false);
      setFieldError('location', '')
      getAddressesFromRemote(countries, values, 'verify');
      setIsSubmit(false);
    }
  }, [isSubmit]);

  useEffect(() => {
    if (isFullLocationPage) {
      const tempErrors = []
      Object.keys(errors).forEach((errorKey) => {
        !!errors[errorKey] && tempErrors.push(errors[errorKey])
      })
      if (tempErrors.length) {
        setTopErrorMessages(tempErrors)
        setScrollWatcher(!scrollWatcher)
      }
    }
  }, [isSubmitting])

  useEffect(() => {
    if (topErrorContainer.current) {
      topErrorContainer.current.focus()
      topErrorContainer.current.scrollIntoView()
    }
  }, [scrollWatcher])

  // Clear errors when canceled or new location selected
  useEffect(() => {
    setTopErrorMessages([])
  }, [currentAddress.locationName])

  const {
    locationName,
    street,
    suite,
    city,
    postalCode,
    state,
    country,
    lat,
    lon,
    id,
    addressGeoCodingSource,
    pristineLocationName,
    locationId,
    arriveDate,
    expireDate,
    locationSource,
    travelSegment
  } = values;

  const isExpectedLocationEditable = (expLocEditable && (addressGeoCodingSource == "Manual") && travelSegment == null) || !id;
  
  return (
    <div>
      {
        isShowAlertInfo &&
          <AlertInfoWin
            isOpen={isShowAlertInfo}
            title={alertTitle}
            handleConfirm={setIsShowAlertInfo}
            content={content}
            ebTestValue="wheather-alert-ok"
          />
      }
      {
        isFullLocationPage && <p><I18N>form.fields.are.required</I18N></p>
      }
      <div className="row">
        <div className="col-12">
          {
            !!topErrorMessages.length && isFullLocationPage &&
          <div className="error-container" ref={topErrorContainer} tabIndex="-1">
            <p id="error-instruction" className="mb-1">
              <I18N>form.error.messages.group.title</I18N>
            </p>
            <ul id="error-list">
              {
                topErrorMessages.map((error, index) => (<li key={error + index}><I18N>{error}</I18N></li>))
              }
            </ul>
          </div>
          }
        </div>
      </div>
      <div className="form-group row">
        <FieldSection
          className="col-md-12"
          name="locationName"
          title="ssp.address.locationname"
          maxLength="40"
          readOnly={isExpectedLocation? !isExpectedLocationEditable : !addresseEditable}
          onChange={e => {
            setFieldValue('locationName', e.target.value)
            if (e.target.value.trim()) {
              setFieldError('locationName', '');
            }
          }}
          // cancel the onblur validation
          onBlur={(e) => {
            if ((!isFullLocationPage && addressMandatory) || isFullLocationPage) {
              handleBlur(e)
            }
          }}
          isOptional={!isFullLocationPage && !addressMandatory}
          {...{ values, touched, errors }}
        />
      </div>
      { isExpectedLocation && 
      <div className="form-group row">
        <DateSection
          className="col-md-6"
          name="arriveDate"
          title="ssp.address.start.date"
          maxLength="40"
          setFieldValue={setFieldValue}
          readOnly={!isExpectedLocationEditable}
          isDisable={!isExpectedLocationEditable}
          onChange={e => {
            setFieldValue('arriveDate', e.target.value)
            if (e.target.value.trim()) {
              setFieldError('arriveDate', '');
            }
          }}
          // cancel the onblur validation
          onBlur={(e) => {
            if ((!isFullLocationPage && addressMandatory) || isFullLocationPage) {
              handleBlur(e)
            }
          }}
          {...{ values, touched, errors }}
        />
        <DateSection
          className="col-md-6"
          name="expireDate"
          title="ssp.address.end.date"
          maxLength="40"
          setFieldValue={setFieldValue}
          readOnly={!isExpectedLocationEditable}
          isDisable={!isExpectedLocationEditable}
          onChange={e => {
            setFieldValue('expireDate', e.target.value)
            if (e.target.value.trim()) {
              setFieldError('expireDate', '');
            }
          }}
          // cancel the onblur validation
          onBlur={(e) => {
            if ((!isFullLocationPage && addressMandatory) || isFullLocationPage) {
              handleBlur(e)
            }
          }}
          {...{ values, touched, errors }}
        />
      </div>
      }
      <div className="form-group row">
        <FieldSection
          className="col-md-12"
          name="street"
          title="ssp.address.streetaddress"
          // maxLength="100"
          autoComplete="address-line1"
          onChange={e => {
            setFieldError('street', '');
            const streetValue = e.target.value;
            // set lat & lng empty
            setFieldError('street', '');
            clearPosition({ setFieldValue, name: 'street', value: streetValue });
            getAddresses(
              countries,
              {
                ...values,
                street: streetValue
              });
            if (!streetValue) {
              if (!isFullLocationPage && !addressMandatory) {
                setIsAddressVerifyPass(false);
                setShowAddressVerifyTip(false);
                setFieldError('location', '')
              }
              setShowSuggestion(false);
            }
          }}
          onBlur={handleOnblur}
          readOnly={isExpectedLocation? !isExpectedLocationEditable : !addresseEditable}
          isOptional={!isFullLocationPage && !addressMandatory}
          {...{ values, touched, errors }}
        />
      </div>
      {
        showSuggestion && (
          <Suggestion
            geocodingAddresses={geocodingAddresses}
            handleSuggestion={handleSuggestion}
            isColFull
            handleOnblur={handleOnblur}
          />
        )
      }
      <div className="form-group row">
        <FieldSection
          className="col-md-12"
          name="suite"
          title="ssp.address.suite"
          maxLength="75"
          autoComplete="address-line2"
          isOptional
          readOnly={isExpectedLocation? !isExpectedLocationEditable : !addresseEditable}
          // cancel the onblur validation
          onBlur={() => {}}
          {...{ values, touched, errors }}
        />
      </div>
      <div className="form-group row">
        <FieldSection
          className="col-md-6"
          name="city"
          onChange={e => {
            // set lat & lng empty
            clearPosition({ setFieldValue, name: 'city', value: e.target.value });
          }}
          title="ssp.address.city"
          maxLength="40"
          autoComplete="address-level2"
          isOptional
          readOnly={isExpectedLocation? !isExpectedLocationEditable : !addresseEditable}
          // cancel the onblur validation
          onBlur={() => {}}
          {...{ values, touched, errors }}
        />
        <StateSection
          className="col-md-6"
          {...{ values, states, setFieldValue, addresseEditable: isExpectedLocation? isExpectedLocationEditable: addresseEditable }}
        />
      </div>
      <div className="form-group row">
        <FieldSection
          className="col-md-6"
          name="postalCode"
          title="ssp.address.postalcode"
          isOptional
          onChange={e => {
            // set lat & lng empty
            clearPosition({ setFieldValue, name: 'postalCode', value: e.target.value });
          }}
          // cancel the onblur validation
          onBlur={() => {}}
          readOnly={isExpectedLocation? !isExpectedLocationEditable : !addresseEditable}
          {...{ values, touched, errors }}
        />
        <CountrySection
          className="col-md-6"
          {...{ values, countries, setFieldValue, addresseEditable: isExpectedLocation? isExpectedLocationEditable : addresseEditable }}
        />
      </div>
      {
        isOpenEditLocation && (
          <LatitudeAndLongitude
            {...{ values, touched, errors }}
            showlatitudeAndLongitude={showlatitudeAndLongitude}
            showLatitudeAndLongitudeHelpContent={() => setShowlatitudeAndLongitude(true)}
            hideLatitudeAndLongitudeHelpContent={() => setShowlatitudeAndLongitude(false)}
            readOnly={isExpectedLocation? !isExpectedLocationEditable : !addresseEditable}
          />
        )
      }
      <div className="form-group row margin50-T">
        <div className="offset-md-3 col-md-9">
          <div className="row justify-content-end">
            {
              isFullLocationPage &&
                <div className="col-md-4">
                  {
                    !(addressMandatory && isEmptyLocation) && 
                       (
                        <button
                          type="button"
                          className="btn btn-secondary btn-block"
                          onMouseDown={(e) => { e.preventDefault(); }}
                          onClick={() => {
                            if (isEditMode && isEmptyLocation) {
                              navigate('home');
                            }
                            closeLocation();
                          }}
                        >
                          <I18N>global.dialog.button.cancel</I18N>
                        </button>
                      )
                  }
                </div>
            }
            {
              (isExpectedLocation? isExpectedLocationEditable : addresseEditable) &&
              <div className="col-md-8">
                <button
                  ref={verifyButton}
                  disabled={!isFullLocationPage && (!locationName || !street)}
                  type={isFullLocationPage ? 'submit' : 'button'}
                  className="btn btn-primary btn-block"
                  eb-test="ssp-mylocation-button-verify-location"
                  onMouseDown={(e) => { e.preventDefault(); }}
                  onClick={() => {
                    verifyButton.current.focus();
                    if (isFullLocationPage) {
                      handleSubmit();
                    } else {
                      setShowAddressVerifyTip(false);
                      setFieldError('location', '')
                      if (errors.postalCode) {
                        return false;
                      }
                      getAddressesFromRemote(countries, values, 'verify');
                    }
                  }}
                >
                  <I18N>ssp.location.verify.address</I18N>
                </button>
                {isShowAddressVerifyTip && (
                  <FieldErrorMessage>
                    <I18N>ssp.map.verify.your.location</I18N>
                  </FieldErrorMessage>
                )}
              </div>
            }
          </div>
        </div>
      </div>
      {
        isOpenVerifyLocation && (
          <VerifyLocationModal
            whichOnePosition={whichOnePosition}
            close={() => setIsOpenVerifyLocation(false)}
            handleWhichOnePosition={setWhichOnePosition}
            ok={address => {
              verifyLocation({
                addresses: [address],
              });
              handleAddressUpdate(address);
              setIsOpenVerifyLocation(false);
              setIsAddressVerifyPass(true);
            }}
            setSavedSucceed={setSavedSucceed}

            address={{
              locationName,
              street,
              suite,
              city,
              postalCode,
              state,
              country,
              arriveDate,
              expireDate,
              countryName: getCountryName(country),
            }}
            saveAddress={{
              locationName,
              streetAddress: street,
              suite,
              city,
              postalCode,
              state,
              country,
              lat,
              lon,
              id,
              addressGeoCodingSource,
              pristineLocationName,
              locationId,
              arriveDate,
              expireDate,
            }}
            geocodingAddresses={geocodingAddresses}
            geocodingType={geocodingType}
            updateLocation={isOpenEditLocation}
            closeLocation={closeLocation}
            isUpdateLocationList={isFullLocationPage}
            userAddressList={userAddressList}
            setFieldValue={setFieldValue}
            isExpectedLocation={isExpectedLocation}
            id={id}
          />
        )
      }
    </div>
  );
};

AddLocationInformationForm.propTypes = {
  isFullLocationPage: PropTypes.bool.isRequired,
  userAddressList: PropTypes.arrayOf(PropTypes.object),
  isEmptyLocation: PropTypes.bool,
  openAddLocation: PropTypes.func,
  closeLocation: PropTypes.func,
  isShowAddressVerifyTip: PropTypes.bool,
  isOpenEditLocation: PropTypes.bool.isRequired,
  states: PropTypes.arrayOf(PropTypes.object).isRequired,
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  fetchInitData: PropTypes.func.isRequired,
  fetchAddresses: PropTypes.func.isRequired,
  geocodingAddresses: PropTypes.arrayOf(PropTypes.object).isRequired,
  verifyLocation: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  isExpectedLocation: PropTypes.bool,
  expLocEditable: PropTypes.bool,
  currentAddress: PropTypes.shape(),
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  isSubmit: PropTypes.bool,
  setIsSubmit: PropTypes.func,
  shouldIncidentSubShow: PropTypes.bool.isRequired,
};
AddLocationInformationForm.defaultProps = {
  userAddressList: [],
  isEmptyLocation: true,
  closeLocation: () => {},
  openAddLocation: () => {},
  isShowAddressVerifyTip: false,
  isEditMode: false,
  isExpectedLocation: false,
  expLocEditable: false,
  currentAddress: {},
  handleSubmit: () => {},
  isSubmit: false,
  setIsSubmit: () => {},
};
const mapStateToProps = state => ({
  geocodingAddresses: locationSelectors.selectLocationGeocodingAddresses(state),
  states: locationSelectors.selectLocationStates(state),
  countries: locationSelectors.selectLocationCountries(state),
  shouldIncidentSubShow: selectShouldShowIncidentSub(state),
});

const mapDispatchToProps = dispatch => ({
  fetchInitData: () => dispatch(locationActions.fetchStatesAndCountries.action()),
  fetchAddresses: payload =>
    dispatch(locationActions.fetchGeocodingAddresses.action(payload)),
  verifyLocation: payload => dispatch(locationActions.verifyLocation(payload)),
  saveGeocodingAddress: address =>
    dispatch(locationActions.saveGeocodingAddress.action({ address })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddLocationInformationForm);
